import { App } from 'antd';
import { Suspense, lazy, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { describeUploadOutcome } from '@/domain/music';
import { useMusicPlayerStore } from './music-player-store';
import { useMusicUploadStore } from './music-upload-store';

const MUSIC_PATH = '/music';

// Thanh nghe + thanh tiến độ chỉ tải về khi thật sự có gì để hiện: đa số người dùng không mở Kho nhạc
// trong một buổi làm việc, không có lý do gì bắt họ tải phần này ngay lúc mở app.
const MusicDockPanel = lazy(() =>
  import('./MusicDockPanel').then((m) => ({ default: m.MusicDockPanel })),
);

/**
 * Phần của Kho nhạc sống NGOÀI màn «Kho nhạc», gắn dưới đáy khung ứng dụng: thanh nghe (sang mục khác
 * nhạc vẫn phát) và tiến độ đưa nhạc lên (lô vài chục file chạy nền trong lúc người dùng làm việc
 * khác). Không có gì để hiện thì không chiếm chỗ.
 */
export function MusicDock() {
  const { message } = App.useApp();
  const onMusicPage = useLocation().pathname === MUSIC_PATH;
  const hasTrack = useMusicPlayerStore((state) => state.current !== null);
  const uploading = useMusicUploadStore((state) => state.batches.length > 0);
  const finished = useMusicUploadStore((state) => state.finished);
  const acknowledge = useMusicUploadStore((state) => state.acknowledge);

  // Lô nào xong cũng báo, dù người dùng đang đứng ở mục nào.
  useEffect(() => {
    for (const batch of finished) {
      const { tone, text } = describeUploadOutcome(batch);
      void message[tone](text, tone === 'warning' ? 8 : 3);
      acknowledge(batch.id);
    }
  }, [finished, acknowledge, message]);

  // Ở màn «Kho nhạc» tiến độ đã hiện ngay trong thư mục đang nhận file.
  const showUploads = uploading && !onMusicPage;
  if (!hasTrack && !showUploads) return null;
  return (
    <Suspense fallback={null}>
      <MusicDockPanel showUploads={showUploads} />
    </Suspense>
  );
}
